import React, { useEffect } from 'react';
import {
  QueryClientProvider,
  QueryClient,
  QueryCache,
  MutationCache,
} from 'react-query';
import useAuthContext from '../hooks/useAuthContext';
import { AuthContextProvider } from '../context/authContext';
import App from '.';
import { CreditContextProvider } from '../context/creditContext';
import { message } from 'antd';
import { useSearchParams } from 'react-router-dom';
import config from '../config';

const AppInitializer = () => {
  const { dispatcher } = useAuthContext();
  const [searchParams] = useSearchParams();


  useEffect(() => {
    let dbId = sessionStorage.getItem('mm:dbId');
    let urldbId = searchParams.get('dbId');

    if (!!urldbId) {
      sessionStorage.setItem('mm:dbId', urldbId);
    } else if (!dbId) {
      sessionStorage.setItem('mm:dbId', config.distributerId);
    }
  }, []);

  const logoutHandler = () => {
    dispatcher({
      type: 'LOGOUT',
    });
    localStorage.removeItem('mm:user');
    sessionStorage.clear();
    window.location.href = '/login';
  };

  const queryError = (error, query) => {
    if (error?.response?.status === 401) {
      message.error('Unauthorised');
      logoutHandler();
    }
  };

  const queryClient = new QueryClient({
    queryCache: new QueryCache({
      onError: queryError,
    }),
    mutationCache: new MutationCache({
      onError: queryError,
    }),
  });

  return (
    <>
      <QueryClientProvider client={queryClient}>
        <AuthContextProvider>
          <CreditContextProvider>
            <App />
          </CreditContextProvider>
        </AuthContextProvider>
      </QueryClientProvider>
    </>
  );
};

export default AppInitializer;
